import React from 'react';    
import { Line } from 'react-chartjs-2'; // 折れ線グラフ用のコンポーネントをインポート  
import 'chart.js/auto'; // Chart.js自動登録  
  
function formatDate(isoDateString) {    
    const date = new Date(isoDateString);    
    return date.toLocaleDateString('en-CA'); // YYYY-MM-DD形式で返す    
}    
    
function RobotTelemetryTable({ telemetryData }) {    
  if (telemetryData.length === 0) {    
    return <div>データがありません。</div>;    
  }    
  
  const tableStyle = {  
    borderCollapse: 'collapse',  
    width: '100%',  
    textAlign: 'left',  
    marginBottom: '20px', // 表とグラフの間隔を設定  
  };  
  
  const cellStyle = {  
    border: '1px solid black',  
    padding: '8px',  
  };  
  
  // グラフ用のデータを準備  
  const chartData = {  
    labels: telemetryData.map(data => formatDate(data.day)),  
    datasets: [  
      {  
        label: '収穫成功数',  
        data: telemetryData.map(data => data.eventCounts.ok),  
        borderColor: 'green',  
        backgroundColor: 'green',  
        fill: false, // 塗りつぶしを無効にする
      },
      {  
        label: '収穫見送り数',  
        data: telemetryData.map(data => data.eventCounts.ng),  
        borderColor: 'blue',  
        backgroundColor: 'blue',  
        fill: false, // 塗りつぶしを無効にする
      }  
    ]  
  };  
  
  return (    
    <div>  
      <Line data={chartData} /> {/* グラフの描画 */}
      <table style={tableStyle}>    
        <thead>    
          <tr>    
            <th style={cellStyle}>日付</th>    
            <th style={cellStyle}>稼働時間（分）</th>    
            {/* <th style={cellStyle}>発見数</th>     */}
            {/* <th style={cellStyle}>近づいた数</th>   */}
            <th style={cellStyle}>収穫挑戦数</th>      
            <th style={cellStyle}>収穫成功数</th>    
            <th style={cellStyle}>収穫見送り数</th>  
          </tr>    
        </thead>    
        <tbody>    
          {telemetryData.map((data, index) => (    
            <tr key={index}>    
              <td style={cellStyle}>{formatDate(data.day)}</td>    
              <td style={cellStyle}>{data.workingTime.toFixed(2)}</td>    
              {/* <td style={cellStyle}>{data.eventCounts.found || 0}</td>     */}
              {/* <td style={cellStyle}>{data.eventCounts.approached || 0}</td>     */}
              <td style={cellStyle}>{data.eventCounts.harvested || 0}</td>   
              <td style={cellStyle}>{data.eventCounts.ok || 0}</td>  
              <td style={cellStyle}>{data.eventCounts.ng || 0}</td>    
            </tr>    
          ))}    
        </tbody>    
      </table>      
    </div>    
  );    
}    
    
export default RobotTelemetryTable;  
